<template>
<div class="help">
  <!--头部导航-->
  <top-nav ref="TopNav"></top-nav>
  <van-nav-bar title="帮助中心" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
    <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
  </van-nav-bar>
  <div id="help" class="van-content">
    <div style="padding: 15px" v-if="maincontent!=null||maincontent!=''" id="question">
      <p class="title">{{title}}</p>
      <div class="detailCont" v-html="maincontent">{{maincontent}}</div>
    </div>
    <!--<div style="margin-top: 0"  class="nodata text-cent" v-if=" maincontent == ''">-->
      <!--<P class="imgbox">-->
        <!--<img src="/static/images/nodataimg2.png"/>-->
      <!--</P>-->
      <!--<p class="text">还没有相关数据~</p>-->
    <!--</div>-->
  </div>
</div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "index",
    components: {
      TopNav
    },
    data (){
      return {
        datas:'',
        activeName: ['1'],
        maincontent:'',
        title:'',
        id:this.$route.query.id,
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      getDatas:function () {
        this.$api.post('/WebApi/Article/Index/detail',  {id:this.id}, res => {
          if (res.data.code == '100') {
            this.datas= res .data.data
            this.maincontent= res .data.data.content
            this.title=res .data.data.title
          }
        })
      }
    },
    mounted () {
      this.getDatas()
    },

  }
</script>

<style scoped>
  #help{
    background: #fff;
    padding-top: 55px!important;
    padding-bottom: 0;
    margin-top: 0;

  }
  #help .nodata{
    background: #f2f2f2;
  }
  #help .detailCont img{
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/help/detail.vue